export default function formatTimeInterval(start, end) {
  const timeDiffMilliseconds = Math.abs(end - start);
  const hours = Math.floor(timeDiffMilliseconds / (60 * 60 * 1000));
  const minutes = Math.floor((timeDiffMilliseconds % (60 * 60 * 1000)) / (60 * 1000));

  return `${hours == 0 ? "" : hours + "h "}${minutes == 0 ? "" : minutes + "min"}`;
}
